import React from "react";
import styled from "styled-components";
import {
  CenteredMainContainer,
} from "storybook-components/Container";

const Container = styled(CenteredMainContainer)`
  padding: 32px 16px;
  ${({ theme }) => theme.media.tabletUp`
    display: block;
    flex-wrap: wrap;
    padding: 60px 0 0 60px;
  `};
  ${({ theme }) => theme.media.desktopUp`
    min-width: 600px;
  `};
  ${({ theme }) => theme.media.wideScreenUp`
    min-width: 800px;
  `};
`;

const MainContainer = ({ children, className }) => {
  return <Container className={className}>{children}</Container>;
};

export default MainContainer;
